import { httpClient } from './core';

/** Google-Kalender fürs Lehrerportal (LEHR-3.4). Der Clientschlüssel kommt nie zurück. */
export interface GoogleKalenderEinstellungen {
  enabled: boolean;
  clientId: string;
  clientSecretIsSet: boolean;
  redirectUri: string;
  connectedTeachers: number;
  encryptionConfigured: boolean;
  scopes: string[];
}

export interface GoogleKalenderSpeichern {
  enabled?: boolean;
  clientId?: string;
  /** Nur senden, wenn ein neuer Schlüssel eingegeben wurde. */
  clientSecret?: string;
  clearClientSecret?: boolean;
  redirectUri?: string;
}

export const googleKalenderApi = {
  get: async (): Promise<GoogleKalenderEinstellungen> => {
    const res = await httpClient<GoogleKalenderEinstellungen>('/api/settings/google-calendar');
    if (res.error || !res.data) throw new Error(res.error || 'Google-Kalender-Einstellungen konnten nicht geladen werden');
    return res.data;
  },
  update: async (payload: GoogleKalenderSpeichern): Promise<GoogleKalenderEinstellungen> => {
    const res = await httpClient<GoogleKalenderEinstellungen>('/api/settings/google-calendar', {
      method: 'PUT',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'Speichern fehlgeschlagen');
    return res.data;
  },
};
